module.exports = __webpack_public_path__ + "static/media/intro.e4464606.mp3";